export const indianStates = [
  {
    state_name: "Andaman and Nicobar Islands",
    id: "1",
  },
  {
    state_name: "Andhra Pradesh",
    id: "2",
  },
  {
    state_name: "Arunachal Pradesh",
    id: "3",
  },
  {
    state_name: "Assam",
    id: "4",
  },
  {
    state_name: "Bihar",
    id: "5",
  },
  {
    state_name: "Chandigarh",
    id: "6",
  },
  {
    state_name: "Chhattisgarh",
    id: "7",
  },
  {
    state_name: "Dadra and Nagar Haveli",
    id: "8",
  },
  {
    state_name: "Daman and Diu",
    id: "9",
  },
  {
    state_name: "Delhi",
    id: "10",
  },
  {
    state_name: "Goa",
    id: "11",
  },
  {
    state_name: "Gujarat",
    id: "12",
  },
  {
    state_name: "Haryana",
    id: "13",
  },
  {
    state_name: "Himachal Pradesh",
    id: "14",
  },
  {
    state_name: "Jammu and Kashmir",
    id: "15",
  },
  {
    state_name: "Jharkhand",
    id: "16",
  },
  {
    state_name: "Karnataka",
    id: "17",
  },
  {
    state_name: "Kerala",
    id: "18",
  },
  {
    state_name: "Ladakh",
    id: "19",
  },
  {
    state_name: "Lakshadweep",
    id: "20",
  },
  {
    state_name: "Madhya Pradesh",
    id: "21",
  },
  {
    state_name: "Maharashtra",
    id: "22",
  },
  {
    state_name: "Manipur",
    id: "23",
  },
  {
    state_name: "Meghalaya",
    id: "24",
  },
  {
    state_name: "Mizoram",
    id: "25",
  },
  {
    state_name: "Nagaland",
    id: "26",
  },
  {
    state_name: "Odisha",
    id: "27",
  },
  {
    state_name: "Puducherry",
    id: "28",
  },
  {
    state_name: "Punjab",
    id: "29",
  },
  {
    state_name: "Rajasthan",
    id: "30",
  },
  {
    state_name: "Sikkim",
    id: "31",
  },
  {
    state_name: "Tamil Nadu",
    id: "32",
  },
  {
    state_name: "Telangana",
    id: "33",
  },
  {
    state_name: "Tripura",
    id: "34",
  },
  {
    state_name: "Uttar Pradesh",
    id: "35",
  },
  {
    state_name: "Uttarakhand",
    id: "36",
  },
  {
    state_name: "West Bengal",
    id: "37",
  },
];
